import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'
import { StatusCodeToError } from 'components/ordering/rma/api/dtos/error.js'

const EXPECTED_ERRORS = [400] as const
type ExpectedErrors = StatusCodeToError<typeof EXPECTED_ERRORS[number]>

type CreateRmaLinePayload = {
  rmaId: string
  product: number
  quantity: number
  reason: number | null
  memo: string | null
  memo2: string | null
  memo3: string | null
  originMove?: number | null
  is_delivered_product?: boolean
  pictures?: { identifier: string }[]
}

export class CreateRmaLine extends RmaRequest<null, ExpectedErrors> {
  path: string
  override expectedErrors = EXPECTED_ERRORS
  override init: RequestInit

  constructor({ rmaId, product, quantity, reason, memo, memo2, memo3, originMove, is_delivered_product, pictures }: CreateRmaLinePayload) {
    super()
    this.path = `account/rma/draft/create/${rmaId}/line/`
    this.init = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ product, quantity, reason, memo, memo2, memo3, originMove, is_delivered_product, pictures }),
    }
  }
}
